export const css = {
	root: '_2jL4b7K1',
	pane: '_38CHOEak',
	heading: '_2sUSoDWU',
	body: '_2FW6-8ok',
	exit: '_1HnqVEQP',
	collapse: 'YA69MNQr',
	enter: '_2TGjqN7Q',
	expand: '_3w9MSomG',
	' _key': 'ascm-theme/ascm/base-widgets/accordion2'
};

export default css;
